import { render, staticRenderFns } from "./TourMetaForm.vue?vue&type=template&id=70356cc8&scoped=true&"
import script from "./TourMetaForm.vue?vue&type=script&lang=js&"
export * from "./TourMetaForm.vue?vue&type=script&lang=js&"
import style0 from "./TourMeta.scss?vue&type=style&index=0&id=70356cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70356cc8",
  null
  
)

export default component.exports